import { useState, useEffect, useRef } from "react";
export default function NationwideShowrooms() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const locations = ["BIRMINGHAM", "BRISTOL", "HAMPSHIRE"];
  return;
}